import BaseComponent from '../base/baseComponent';
import customEventBus from '../libs/eventBus';
import a11yUtils from '../utilities/a11yUtils';
import keyboardUtils from '../utilities/keyboardUtils';
export default class SortingTrigger extends BaseComponent {
    get SELECTORS() {
        return {
            sortingWrapper: '.sorting--wrapper',
            sortingCta: '.toolbar-container .toolbar-cta--sorting',
            toolbar: '.plp-page .toolbar',
            refinementsCta: '.toolbar-container .toolbar-cta--refinements',
            refinementsWrapper: '.refinements--wrapper',
        };
    }
    get CLASSES() {
        return {
            open: 'open',
            sortingCta: 'toolbar-cta--sorting',
            sortingOpen: 'sorting-open',
            filterOpen: 'filter-open'
        };
    }
    constructor(element) {
        super(element);
        customEventBus.on('filter:trigger', (data) => {
            this.hideSortingWrapper();
        });
        this.handleClick();
        this.handleKeyDown();
    }
    handleClick() {
        const sortingWrapper = document.querySelector(this.SELECTORS.sortingWrapper);
        const refinementsWrapper = document.querySelector(this.SELECTORS.refinementsWrapper);
        const toolbar = document.querySelector(this.SELECTORS.toolbar);
        document.querySelector('body').addEventListener('click', (e) => {
            if (!e.target.closest('#refinements-wrapper') && !e.target.closest('#sorting-wrapper') && !e.target.classList.contains('toolbar-cta--refinements') && !e.target.classList.contains('toolbar-cta--sorting') && !e.target.closest('.toolbar-cta--refinements') && !e.target.closest('.toolbar-cta--sorting')) {
                this.closeSorting(toolbar, sortingWrapper);
            }
        });
        this._el.addEventListener('click', (e) => {
            this.toggleSorting(toolbar, sortingWrapper);
        });
    }
    toggleSorting(toolbar, sortingWrapper) {
        customEventBus.emit('sorting:trigger', {});
        this._el.classList.toggle(this.CLASSES.open);
        if (toolbar) {
            toolbar.classList.toggle(this.CLASSES.sortingOpen);
        }
        if (!this._el.classList.contains(this.CLASSES.sortingCta)) {
            let refinementsCta = document.querySelector(this.SELECTORS.sortingCta);
            if (refinementsCta) {
                refinementsCta.classList.toggle(this.CLASSES.open);
            }
        }
        if (sortingWrapper) {
            sortingWrapper.classList.toggle(this.CLASSES.open);
            if (this._el.classList.contains(this.CLASSES.open)) {
                a11yUtils.focusTrapOn(sortingWrapper);
                sortingWrapper.focus();
            }
            else {
                a11yUtils.focusTrapOff();
            }
        }
    }
    closeSorting(toolbar, sortingWrapper) {
        this._el.classList.remove(this.CLASSES.open);
        if (toolbar) {
            toolbar.classList.remove(this.CLASSES.sortingOpen);
        }
        let refinementsCta = document.querySelector(this.SELECTORS.sortingCta);
        if (refinementsCta) {
            refinementsCta.classList.remove(this.CLASSES.open);
        }
        if (sortingWrapper) {
            sortingWrapper.classList.remove(this.CLASSES.open);
        }
        a11yUtils.focusTrapOff();
    }
    handleKeyDown() {
        const sortingWrapper = document.querySelector(this.SELECTORS.sortingWrapper);
        const toolbar = document.querySelector(this.SELECTORS.toolbar);
        if (sortingWrapper) {
            sortingWrapper.addEventListener('keydown', (e) => {
                if (keyboardUtils.isEscKey(e)) {
                    e.preventDefault();
                    this.closeSorting(toolbar, sortingWrapper);
                }
            });
        }
    }
    hideSortingWrapper() {
        const sortingWrapper = document.querySelector(this.SELECTORS.sortingWrapper);
        const toolbar = document.querySelector(this.SELECTORS.toolbar);
        this._el.classList.remove(this.CLASSES.open);
        toolbar.classList.remove(this.CLASSES.sortingOpen);
        sortingWrapper.classList.remove(this.CLASSES.open);
    }
}
